<template>
  <div class="blog-grid">
    <div class="container">
      <div class="row">
        <div class="col-md-7">
          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="10"
          >
            <div class="articles" v-if="loading">
              <ArticleSecondSkeleton v-for="(article, i) in 3" :key="i" />
            </div>
            <div class="articles" v-else>
              <ArticleSecond
                :article="article"
                v-for="(article, i) in blogsToShow"
                :key="i"
                :bookMarks="bookMarks"
                @bookMarkBlog="bookMarkBlog"
              />
            </div>
            <ArticleSecondSkeleton v-if="loadingNew" />
          </div>
        </div>
        <div class="col-md-5">
          <div class="related-content">
            <h2 class="heading">DISCOVER MORE OF WHAT MATTERS TO YOU</h2>
            <div class="tags" v-if="loading">
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
              <b-skeleton type="button" class="skeleton-tag"></b-skeleton>
            </div>
            <div class="tags" v-else>
              <div v-for="(tag, i) in tags" class="tag" :key="i">{{ tag }}</div>
            </div>
            <div class="ad-area">
              <InArticleAdsense
                data-ad-client="ca-pub-4193943538824548"
                data-ad-slot="6110067459"
              >
              </InArticleAdsense>
            </div>

            <template
              v-if="config.features.guides && (guides.length > 0 || loading)"
            >
              <h2 class="heading top-guide">TOP GUIDES</h2>
              <div class="top-guides" v-if="loading">
                <div v-for="(guide, i) in 3" :key="i">
                  <div class="small-card" v-if="i < 3">
                    <div class="profile-img">
                      <b-skeleton type="avatar"></b-skeleton>
                    </div>
                    <h4 class="name">
                      <b-skeleton
                        type="button"
                        height="15px"
                        width="60px"
                      ></b-skeleton>
                    </h4>
                  </div>
                </div>
              </div>
              <div class="top-guides" v-else>
                <div v-for="(guide, i) in guides" :key="i">
                  <div
                    class="small-card"
                    v-if="i < 4"
                    @click="goToGuide(guide.profile.profileName)"
                  >
                    <div class="profile-img">
                      <img
                        class="avatar"
                        v-if="guide.user.imgURL"
                        :src="guide.user.imgURL"
                        :alt="guide.user.firstname"
                      />
                      <b-avatar
                        v-else
                        class="avatar"
                        :text="
                          getInitials(guide.user.firstname, guide.user.lastname)
                        "
                      />
                      <span class="ico-top">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle cx="8" cy="8" r="8" fill="white" />
                          <circle
                            cx="8.00156"
                            cy="8.0001"
                            r="6.4"
                            fill="#557EFB"
                          />
                          <path
                            d="M5.57227 5.2471C5.57227 6.38781 7.09767 7.79215 7.99777 8.36469C8.96559 7.74119 10.4113 6.67062 10.4113 5.37653C10.4113 4.76195 10.0529 4.00006 9.31209 4.00006C8.71945 4.00006 8.24869 4.2589 7.99777 4.72946C7.73491 4.24713 7.04191 4.00006 6.70736 4.00006C6.3728 4.00006 5.57227 4.00006 5.57227 5.2471Z"
                            stroke="white"
                            stroke-width="0.5"
                          />
                          <path
                            d="M6.2896 10.3294C6.26968 10.2235 6.06258 9.87061 6.06258 9.87061L5.38152 9.22356C5.38152 9.22356 5.02308 8.8471 4.80801 8.60004C4.59294 8.35299 4.57304 8.12946 4.6288 7.98829C4.66268 7.90252 4.78413 7.83535 4.83192 7.83535M4.83192 7.83535C4.89166 7.82359 5.04699 7.84715 5.14256 7.94123C5.25011 8.04711 5.76387 8.55299 6.06258 8.8471C6.36129 9.14121 7.31717 9.52944 7.48445 9.9412C7.65173 10.353 7.53224 11.3529 7.53224 12.0353L5.87141 12.047C5.92319 11.8588 5.87141 11.4706 5.87141 11.1294C5.87141 10.6009 5.26206 10.153 5.07089 10.0118C4.87972 9.87061 4.06721 9.22356 4.06721 8.8471C4.0672 8.11618 3.95874 6.70472 4.01942 6.21185C4.06722 5.82362 4.115 5.61185 4.33007 5.69421C4.54514 5.77656 4.64073 5.94833 4.64073 6.25891C4.64073 6.56949 4.77616 7.44009 4.83192 7.83535Z"
                            stroke="white"
                            stroke-width="0.5"
                          />
                          <path
                            d="M9.71236 10.3294C9.73227 10.2235 9.93937 9.87061 9.93937 9.87061L10.6204 9.22356C10.6204 9.22356 10.9789 8.8471 11.1939 8.60004C11.409 8.35299 11.4289 8.12946 11.3732 7.98829C11.3393 7.90252 11.2178 7.83535 11.17 7.83535M11.17 7.83535C11.1103 7.82359 10.955 7.84715 10.8594 7.94123C10.7518 8.04711 10.2381 8.55299 9.93937 8.8471C9.64066 9.14121 8.68478 9.52944 8.5175 9.9412C8.35023 10.353 8.46971 11.3529 8.46971 12.0353L10.1305 12.047C10.0788 11.8588 10.1305 11.4706 10.1305 11.1294C10.1305 10.6009 10.7399 10.153 10.9311 10.0118C11.1222 9.87061 11.9347 9.22356 11.9347 8.8471C11.9347 8.11618 12.0432 6.70472 11.9825 6.21185C11.9347 5.82362 11.887 5.61185 11.6719 5.69421C11.4568 5.77656 11.3612 5.94833 11.3612 6.25891C11.3612 6.56949 11.2258 7.44009 11.17 7.83535Z"
                            stroke="white"
                            stroke-width="0.5"
                          />
                        </svg>
                      </span>
                    </div>
                    <h4
                      class="name"
                      v-if="guide.user.firstname || guide.user.lastname"
                    >
                      {{ guide.user.firstname + " " + guide.user.lastname }}
                    </h4>
                    <h4 class="name" v-else>Journey Guide</h4>
                    <span class="rating">
                      <svg
                        width="69"
                        height="10"
                        viewBox="0 0 69 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            d="M10.2816 3.52128L7.09642 3.06505L5.67257 0.220085C5.63368 0.142191 5.5697 0.0791345 5.49066 0.0408059C5.29245 -0.0556336 5.05159 0.0247327 4.95248 0.220085L3.52863 3.06505L0.343462 3.52128C0.255647 3.53365 0.175359 3.57445 0.113889 3.63627C0.0395745 3.71155 -0.00137607 3.81283 3.5309e-05 3.91785C0.00144669 4.02287 0.0451045 4.12305 0.121416 4.19636L2.42593 6.41076L1.88148 9.53763C1.86871 9.61037 1.87687 9.68517 1.90505 9.75357C1.93323 9.82197 1.98028 9.88121 2.04088 9.92459C2.10148 9.96797 2.1732 9.99375 2.24791 9.999C2.32262 10.0042 2.39733 9.98876 2.46356 9.9543L5.31253 8.47803L8.16149 9.9543C8.23927 9.9951 8.32959 10.0087 8.41615 9.99386C8.63443 9.95677 8.78121 9.75276 8.74358 9.53763L8.19912 6.41076L10.5036 4.19636C10.5664 4.13578 10.6078 4.05665 10.6203 3.9701C10.6542 3.75373 10.5011 3.55343 10.2816 3.52128Z"
                            fill="#F8D57C"
                          />
                          <path
                            d="M24.9066 3.52128L21.7214 3.06505L20.2976 0.220085C20.2587 0.142191 20.1947 0.0791345 20.1157 0.0408059C19.9175 -0.0556336 19.6766 0.0247327 19.5775 0.220085L18.1536 3.06505L14.9685 3.52128C14.8806 3.53365 14.8004 3.57445 14.7389 3.63627C14.6646 3.71155 14.6236 3.81283 14.625 3.91785C14.6264 4.02287 14.6701 4.12305 14.7464 4.19636L17.0509 6.41076L16.5065 9.53763C16.4937 9.61037 16.5019 9.68517 16.53 9.75357C16.5582 9.82197 16.6053 9.88121 16.6659 9.92459C16.7265 9.96797 16.7982 9.99375 16.8729 9.999C16.9476 10.0042 17.0223 9.98876 17.0886 9.9543L19.9375 8.47803L22.7865 9.9543C22.8643 9.9951 22.9546 10.0087 23.0412 9.99386C23.2594 9.95677 23.4062 9.75276 23.3686 9.53763L22.8241 6.41076L25.1286 4.19636C25.1914 4.13578 25.2328 4.05665 25.2453 3.9701C25.2792 3.75373 25.1261 3.55343 24.9066 3.52128Z"
                            fill="#F8D57C"
                          />
                          <path
                            d="M38.9268 3.52128L35.929 3.06505L34.5889 0.220085C34.5523 0.142191 34.4921 0.0791345 34.4177 0.0408059C34.2311 -0.0556336 34.0044 0.0247327 33.9112 0.220085L32.5711 3.06505L29.5733 3.52128C29.4906 3.53365 29.415 3.57445 29.3572 3.63627C29.2872 3.71155 29.2487 3.81283 29.25 3.91785C29.2514 4.02287 29.2925 4.12305 29.3643 4.19636L31.5332 6.41076L31.0208 9.53763C31.0088 9.61037 31.0165 9.68517 31.043 9.75357C31.0695 9.82197 31.1138 9.88121 31.1708 9.92459C31.2279 9.96797 31.2954 9.99375 31.3657 9.999C31.436 10.0042 31.5063 9.98876 31.5686 9.9543L34.25 8.47803L36.9314 9.9543C37.0046 9.9951 37.0896 10.0087 37.1711 9.99386C37.3765 9.95677 37.5147 9.75276 37.4792 9.53763L36.9668 6.41076L39.1358 4.19636C39.1948 4.13578 39.2338 4.05665 39.2456 3.9701C39.2775 3.75373 39.1334 3.55343 38.9268 3.52128Z"
                            fill="#F8D57C"
                          />
                          <path
                            d="M53.5316 3.52128L50.3464 3.06505L48.9226 0.220085C48.8837 0.142191 48.8197 0.0791345 48.7407 0.0408059C48.5425 -0.0556336 48.3016 0.0247327 48.2025 0.220085L46.7786 3.06505L43.5935 3.52128C43.5056 3.53365 43.4254 3.57445 43.3639 3.63627C43.2896 3.71155 43.2486 3.81283 43.25 3.91785C43.2514 4.02287 43.2951 4.12305 43.3714 4.19636L45.6759 6.41076L45.1315 9.53763C45.1187 9.61037 45.1269 9.68517 45.155 9.75357C45.1832 9.82197 45.2303 9.88121 45.2909 9.92459C45.3515 9.96797 45.4232 9.99375 45.4979 9.999C45.5726 10.0042 45.6473 9.98876 45.7136 9.9543L48.5625 8.47803L51.4115 9.9543C51.4893 9.9951 51.5796 10.0087 51.6662 9.99386C51.8844 9.95677 52.0312 9.75276 51.9936 9.53763L51.4491 6.41076L53.7536 4.19636C53.8164 4.13578 53.8578 4.05665 53.8703 3.9701C53.9042 3.75373 53.7511 3.55343 53.5316 3.52128Z"
                            fill="#F8D57C"
                          />
                          <path
                            d="M68.1566 3.52128L64.9714 3.06505L63.5476 0.220085C63.5087 0.142191 63.4447 0.0791345 63.3657 0.0408059C63.1675 -0.0556336 62.9266 0.0247327 62.8275 0.220085L61.4036 3.06505L58.2185 3.52128C58.1306 3.53365 58.0504 3.57445 57.9889 3.63627C57.9146 3.71155 57.8736 3.81283 57.875 3.91785C57.8764 4.02287 57.9201 4.12305 57.9964 4.19636L60.3009 6.41076L59.7565 9.53763C59.7437 9.61037 59.7519 9.68517 59.78 9.75357C59.8082 9.82197 59.8553 9.88121 59.9159 9.92459C59.9765 9.96797 60.0482 9.99375 60.1229 9.999C60.1976 10.0042 60.2723 9.98876 60.3386 9.9543L63.1875 8.47803L66.0365 9.9543C66.1143 9.9951 66.2046 10.0087 66.2912 9.99386C66.5094 9.95677 66.6562 9.75276 66.6186 9.53763L66.0741 6.41076L68.3786 4.19636C68.4414 4.13578 68.4828 4.05665 68.4953 3.9701C68.5292 3.75373 68.3761 3.55343 68.1566 3.52128Z"
                            fill="#F8D57C"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="68.5" height="10" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="connections.length > 0 || loading">
              <h2 class="heading top-guide">TOP CONNECTIONS</h2>
              <div class="top-guides" v-if="loading">
                <div v-for="(guide, i) in 3" :key="i">
                  <div class="small-card" v-if="i < 3">
                    <div class="profile-img">
                      <b-skeleton type="avatar"></b-skeleton>
                    </div>
                    <h4 class="name">
                      <b-skeleton
                        type="button"
                        height="15px"
                        width="60px"
                      ></b-skeleton>
                    </h4>
                  </div>
                </div>
              </div>
              <div class="top-guides" v-else>
                <div v-for="(connection, i) in connections" :key="i">
                  <div
                    v-if="i < 4"
                    class="small-card"
                    @click="goToConnection(connection.name)"
                  >
                    <div class="profile-img">
                      <img
                        class="avatar"
                        v-if="connection.imgURL"
                        :src="connection.imgURL"
                        :alt="connection.name"
                      />
                      <img
                        class="avatar"
                        v-else
                        src="@/assets/img/blogs/watch.svg"
                        :alt="connection.name"
                      />
                    </div>
                    <h4 class="device-name">{{ connection.name }}</h4>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="tools.length > 0 || loading">
              <h2 class="heading top-guide">TOP TOOLS</h2>
              <div class="top-guides" v-if="loading">
                <div v-for="(guide, i) in 3" :key="i">
                  <div class="small-card" v-if="i < 3">
                    <div class="profile-img">
                      <b-skeleton type="avatar"></b-skeleton>
                    </div>
                    <h4 class="name">
                      <b-skeleton
                        type="button"
                        height="15px"
                        width="60px"
                      ></b-skeleton>
                    </h4>
                  </div>
                </div>
              </div>
              <div class="top-guides" v-else>
                <div v-for="(tool, i) in tools" :key="i">
                  <div
                    v-if="i < 4"
                    class="small-card"
                    @click="goToTool(tool.name)"
                  >
                    <div class="profile-img">
                      <img
                        class="avatar"
                        v-if="tool.imgURL"
                        :src="tool.imgURL"
                        :alt="tool.name"
                      />
                      <img
                        class="avatar"
                        v-else
                        src="@/assets/img/blogs/Nutrition.svg"
                        :alt="tool.name"
                      />
                    </div>
                    <h4 class="device-name">{{ tool.name }}</h4>
                  </div>
                </div>
              </div>
            </template>
            <div class="horizontal-line footer-top"></div>

            <div class="footer" :class="{ fixed: footerFixed }">
              <router-link tag="span" to="/policy/terms"
                ><a>Terms & Condition</a></router-link
              >
              <router-link tag="span" to="/policy/privacy"
                ><a>Privacy Policy</a></router-link
              >
              <router-link tag="span" to="/sessions"
                ><a>Sessions 1:1 Video</a></router-link
              >
              <router-link v-if="config.features.guides" tag="span" to="/guides"
                ><a>Search Expert Guides</a></router-link
              >
              <br />
              <span>
                Copyright © JourneyBinder 2019-2022
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ArticleSecond from "./ArticleSecond";
import ArticleSecondSkeleton from "./ArticleSecondSkeleton";
import Ads from "vue-google-adsense";
import config from "@/assets/_config.json";

Vue.use(require("vue-script2"));
Vue.use(Ads.InArticleAdsense);
var infiniteScroll = require("vue-infinite-scroll");

export default {
  name: "BlogsGrid.vue",
  directives: { infiniteScroll },
  data() {
    return {
      footerFixed: false,
      showSearch: true,
      blogsToShow: [],
      loadingNew: false,
      advertisement: {
        showAd: false
      },
      config
    };
  },
  computed: {
    // tags() {
    //   //If the user is signed in pull from list- if they are not signed in - pull from cookies
    //   return ['finance', 'politics','groups'];
    // }
  },
  props: {
    loading: {
      type: Boolean
    },
    blogs: {
      type: Array
    },
    guides: {
      type: Array
    },
    tools: {
      type: Array
    },
    connections: {
      type: Array
    },
    bookMarks: {
      type: Array
    },
    tags: {
      type: Array
    }
  },
  components: {
    ArticleSecond,
    ArticleSecondSkeleton
  },
  mounted() {
    let that = this;
    let oldScroll;
    window.onscroll = function(e) {
      if (
        document.querySelector(".footer") &&
        document.querySelector(".footer").getBoundingClientRect().top <= 130 &&
        oldScroll < window.scrollY
      ) {
        that.footerFixed = true;
      } else if (
        document.querySelector(".footer") &&
        document.querySelector(".footer-top").getBoundingClientRect().top >= 120
      ) {
        if (oldScroll >= window.scrollY) {
          that.footerFixed = false;
        }
      }
      oldScroll = window.scrollY;
    };
  },
  methods: {
    getInitials(fname, lname) {
      //@TODO- Make this a mixin
      let initials = "";
      if (fname) initials += fname[0];
      if (lname) initials += lname[0];
      return initials;
    },
    goToGuide(name) {
      this.$router.push(`/guide/@${name}`);
    },
    goToTool(name) {
      this.$router.push(`/tool/${name}`);
    },
    goToConnection(name) {
      this.$router.push(`/connection/${name}`);
    },
    pushBlogs() {
      let i = this.blogsToShow.length;
      for (let index = i; index < i + 2; index++) {
        if (this.blogs[index]) {
          this.blogsToShow.push(this.blogs[index]);
        }
      }
    },
    loadMore() {
      if (this.blogs.length > this.blogsToShow.length) {
        this.loadingNew = true;
        setTimeout(() => {
          this.pushBlogs();
          this.loadingNew = false;
        }, 500);
      } else return;
    },
    bookMarkBlog(data) {
      this.$emit("bookMarkBlog", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.blog-grid {
  padding-top: 40px;
  .horizontal-line {
    border-top: 1px solid #ddd;
  }
  .related-content {
    .heading {
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0.03em;
      color: #474d52;
      margin-bottom: 24px;
    }
    .tags {
      user-select: none;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      grid-gap: 8px;
      margin-bottom: 24px;
      .tag {
        height: 42px;
        background: #ffffff;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 48px;
        padding: 10px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #474d52;
        cursor: pointer;
        &:hover {
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
        }
        &.active {
          background: rgba(85, 126, 251, 0.1);
          color: #557efb;
        }
      }
      .skeleton-tag {
        height: 42px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
        border-radius: 48px;
        padding: 10px 16px;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
      }
    }
    .ad-area {
      margin-bottom: 32px;
      img {
        object-fit: cover;
        height: 185px;
        width: 100%;
      }
    }
    .heading.top-guide {
      margin-bottom: 16px;
    }
    .top-guides {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(85px, 1fr));
      grid-column-gap: 14px;
      grid-row-gap: 16px;
      margin-bottom: 48px;
      .small-card {
        cursor: pointer;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        //width: 108px;
        height: 126px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        transition: all 0.3s ease;
        .rating {
          display: grid;
          grid-template-columns: 11px 11px 11px 11px 11px;
          grid-column-gap: 4px;
        }
        &:hover {
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
        }
        .profile-img {
          height: 40px;
          width: 40px;
          position: relative;
          margin-bottom: 9px;
          img {
            height: 100%;
            width: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
          .ico-top {
            position: absolute;
            bottom: 0;
            right: 0;
            transform: translate(25%, 15%);
          }
        }
        .name {
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 19px;
          color: #52595e;
          margin-bottom: 4px;
        }
        .device-name {
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 22px;
          color: #474d52;
        }
      }
    }
  }
  .footer {
    padding-top: 24px;
    padding-bottom: 44px;
    &.fixed {
      position: fixed;
      top: 124px;
    }
    span {
      margin-right: 16px;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #8d99a0;
      a {
        margin-bottom: 11px;
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 22px;
        color: #8d99a0;
      }
    }
  }
}

@media (max-width: 768px) {
  .cols_ {
    flex-direction: column-reverse !important;
  }
  .footer {
    display: none;
  }
}
</style>
